import React from 'react';
import PropTypes from 'prop-types';
import OpportunityIndexTableHeader from './opportunity_index_table_header';
import OpportunityIndexTableRow from './opportunity_index_table_row';

class OpportunityIndexTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opportunities: props.opportunities,
    };
  }

  optionalEmptyMessage = () => {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.opportunities.length == 0) {
      return (
        <tr>
          <td colSpan={999}>Nothing found ...</td>
        </tr>
      );
    }
  };

  render() {
    const { opportunities } = this.state;
    const { currentUserAdmin } = this.props;

    return (
      <table className="table table-striped table-sm table-borderless opportunity-index-table">
        <OpportunityIndexTableHeader currentUserAdmin={currentUserAdmin} />
        <tbody>
          {_.map(opportunities, (opportunity) => (
            <OpportunityIndexTableRow
              key={opportunity.id}
              opportunity={opportunity}
              currentUserAdmin={currentUserAdmin}
            />
          ))}
          {this.optionalEmptyMessage()}
        </tbody>
      </table>
    );
  }
}

OpportunityIndexTable.propTypes = {
  opportunities: PropTypes.arrayOf(Object).isRequired,
  currentUserAdmin: PropTypes.bool.isRequired,
};

OpportunityIndexTable.defaultProps = {};

export default OpportunityIndexTable;
